module.exports = __webpack_public_path__ + "img/avatar.6eb3f2ef.png";